module.exports = __webpack_public_path__ + "ee15307bc385bdfcdb060e4ba8047d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/pipe-valve.svg
// module id = 774
// module chunks = 0